/* No cookie or localStorage dependency: private browsing and blocked storage work. */
(() => {
  'use strict';
  const messages = {
    invalid_email: 'Controlla l’indirizzo email e riprova.',
    invalid_name: 'Inserisci il tuo nome e riprova.',
    consent_required: 'Seleziona il consenso per iscriverti.',
    try_later: 'Ci sono state molte richieste. Attendi qualche minuto e riprova: i tuoi dati restano qui.',
    temporarily_unavailable: 'Non riusciamo a completare la richiesta in questo momento. Riprova tra poco: i tuoi dati restano qui.',
    network: 'La connessione si è interrotta. Riprova: i tuoi dati restano qui.'
  };

  function connect({root, form, onState}) {
    const endpoint = root.dataset.guardEndpoint;
    let token = null;
    let pending = false;
    let sessionPromise = null;
    let receipt = null;
    let pollGeneration = 0;
    const submitButton = form.querySelector('[type="submit"]');
    const buttonLabel = submitButton.querySelector('span');
    const originalLabel = buttonLabel.textContent;

    async function request(path, data) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(endpoint + path, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(data), signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok) throw Object.assign(new Error(result.code || 'network'), {code: result.code});
        return result;
      } catch (error) {
        if (!error.code) error.code = 'network';
        throw error;
      } finally {
        clearTimeout(timeout);
      }
    }

    function prepareSession(force = false) {
      if (token && !force) return Promise.resolve(token);
      if (sessionPromise) return sessionPromise;
      sessionPromise = request('/session', {previous: token}).then(result => {
        token = result.token;
        return token;
      }).finally(() => { sessionPromise = null; });
      return sessionPromise;
    }

    function uiEvent(name) {
      window.dataLayer = window.dataLayer || [];
      // Never place names, addresses, tokens or receipts in analytics.
      window.dataLayer.push({event: name, popup_name: 'spartan_newsletter', popup_version: 'doi_v1'});
    }

    async function pollStatus(pollReceipt) {
      const generation = ++pollGeneration;
      for (let i = 0; i < 12 && generation === pollGeneration; i++) {
        await new Promise(resolve => setTimeout(resolve, 2500));
        try {
          const result = await request('/status', {receipt:pollReceipt});
          if (generation !== pollGeneration) return;
          if (result.status === 'sent') {
            onState('sent');
            uiEvent('spartan_newsletter_confirmation_requested');
            return;
          }
          if (result.status === 'failed' || result.status === 'uncertain') {
            onState(result.status);
            uiEvent('spartan_newsletter_delivery_issue');
            return;
          }
        } catch (_) {
          // A queued request remains stored if this browser loses connectivity.
        }
      }
      if (generation === pollGeneration) onState('delayed');
    }

    async function submit() {
      if (pending || !form.reportValidity()) return;
      pending = true;
      submitButton.disabled = true;
      form.setAttribute('aria-busy', 'true');
      buttonLabel.textContent = 'Invio in corso…';
      onState('sending');
      try {
        const data = {
          email: form.elements.EMAIL.value.trim(),
          name: form.elements.FIRSTNAME.value.trim(),
          consent: form.elements.privacy_consent.checked,
          website: form.elements.website ? form.elements.website.value : ''
        };
        let result;
        for (let attempt = 0; attempt < 2; attempt++) {
          data.token = await prepareSession(attempt > 0);
          try { result = await request('/submit', data); break; }
          catch (error) {
            if (error.code !== 'refresh_session' || attempt > 0) throw error;
          }
        }
        receipt = result.receipt || null;
        onState(result.status);
        uiEvent('spartan_newsletter_request_accepted');
        if (result.status === 'queued' || result.status === 'sending') pollStatus(receipt);
      } catch (error) {
        onState('error', messages[error.code] || messages.temporarily_unavailable);
        uiEvent('spartan_newsletter_request_error');
      } finally {
        pending = false;
        submitButton.disabled = false;
        form.removeAttribute('aria-busy');
        buttonLabel.textContent = originalLabel;
      }
    }

    // This timestamp starts on an actual interaction, not when the script loads.
    root.addEventListener('focusin', () => { prepareSession().catch(() => {}); }, {once:true});
    return {submit, stop: () => {pollGeneration++;}};
  }
  window.SpartanNewsletterGuard = {connect};
  document.dispatchEvent(new CustomEvent('spartan:newsletter-guard-ready'));
})();
